export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crypto ID:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jazyk"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dobré ráno"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dobré odpoledne"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dobrý večer"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dobrou noc"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odhlášení"])}
}